// Scale configurations for slider conversions
// Format: [slider_position_percent, real_value]
export const SCALES = {
  social: [
    [0, 1],
    [50, 20],
    [75, 60],
    [100, 250],
    [105, 251] // Custom plan trigger (250+)
  ],
  users: [
    [0, 1],
    [50, 20],
    [75, 60],
    [100, 200],
    [105, 201] // Custom plan trigger (200+)
  ],
  sources: [
    [0, 1],
    [50, 20],
    [75, 60],
    [100, 250],
    [105, 251] // Custom plan trigger (250+)
  ]
}

// Convert slider value (0-100) to real value based on scale
export function getRealValue(sliderPercent, scaleName) {
  const scale = SCALES[scaleName]

  // Find the segment in the scale
  for (let i = 0; i < scale.length - 1; i++) {
    const [pos1, val1] = scale[i]
    const [pos2, val2] = scale[i + 1]

    if (sliderPercent >= pos1 && sliderPercent <= pos2) {
      // Linear interpolation
      const ratio = (sliderPercent - pos1) / (pos2 - pos1)
      return Math.round(val1 + ratio * (val2 - val1))
    }
  }

  // Fallback to max value
  return scale[scale.length - 1][1]
}

// Convert real value to slider percentage (0-100) based on scale
export function getSliderPercent(realValue, scaleName) {
  const scale = SCALES[scaleName]

  for (let i = 0; i < scale.length - 1; i++) {
    const [pos1, val1] = scale[i]
    const [pos2, val2] = scale[i + 1]

    if (realValue >= val1 && realValue <= val2) {
      const ratio = (realValue - val1) / (val2 - val1)
      return pos1 + ratio * (pos2 - pos1)
    }
  }

  return 100
}

export default SCALES
